// Mock data for Carmaps clone — all content is static / client-side only.

export const NAV_LINKS = [
  { label: "Auto disponibili", href: "#auto" },
  { label: "Come funziona", href: "#verifica" },
  { label: "Chi siamo", href: "#chisiamo" },
  { label: "Contatti", href: "#contatti" },
];

export const HERO_STATS = [
  { value: "Recensioni reali su Google", star: true },
  { value: "Visione e prova su appuntamento" },
  { value: "Foto reali e video quando disponibile" },
];

export const CARS = [
  {
    id: "cm-770065",
    ref: "CM-770065",
    brand: "Audi A1",
    trim: "SPB 35 TFSI S tronic",
    price: "19.000 €",
    oldPrice: "19.900 €",
    year: "2022",
    km: "42.000 km",
    fuel: "Benzina",
    power: "150 CV",
    photos: 48,
    video: true,
    stato: true,
    image:
      "https://images.unsplash.com/photo-1565043666747-69f6646db940?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "cm-654120",
    ref: "CM-654120",
    brand: "Fiat Tipo",
    trim: "Cross",
    price: "10.300 €",
    oldPrice: "11.300 €",
    year: "2022",
    km: "60.000 km",
    fuel: "Benzina",
    power: "100 CV",
    photos: 55,
    video: true,
    stato: true,
    image:
      "https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "cm-338907",
    ref: "CM-338907",
    brand: "Alfa Romeo Stelvio",
    trim: "Executive 2.2 Q4 Automatico",
    price: "15.500 €",
    oldPrice: null,
    year: "2017",
    km: "157.000 km",
    fuel: "Diesel",
    power: "210 CV",
    photos: 19,
    video: false,
    stato: true,
    image:
      "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "cm-771204",
    ref: "CM-771204",
    brand: "Volkswagen Polo",
    trim: "1.0 TSI Life",
    price: "16.900 €",
    oldPrice: "17.500 €",
    year: "2021",
    km: "38.500 km",
    fuel: "Benzina",
    power: "95 CV",
    photos: 42,
    video: true,
    stato: true,
    image:
      "https://images.unsplash.com/photo-1471444928139-48c5bf5173f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "cm-559013",
    ref: "CM-559013",
    brand: "Mercedes-Benz GLA",
    trim: "200 d Automatic Sport",
    price: "23.400 €",
    oldPrice: null,
    year: "2019",
    km: "89.000 km",
    fuel: "Diesel",
    power: "150 CV",
    photos: 61,
    video: true,
    stato: true,
    image:
      "https://images.unsplash.com/photo-1623013274387-45cbcbc1725b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "cm-442810",
    ref: "CM-442810",
    brand: "Hyundai Tucson",
    trim: "1.6 CRDi 48V Xline",
    price: "21.200 €",
    oldPrice: "22.000 €",
    year: "2020",
    km: "74.000 km",
    fuel: "Diesel",
    power: "136 CV",
    photos: 37,
    video: false,
    stato: true,
    image:
      "https://images.unsplash.com/photo-1575090536203-2a6193126514?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "cm-220198",
    ref: "CM-220198",
    brand: "Volkswagen Golf",
    trim: "1.5 TSI Life DSG",
    price: "18.700 €",
    oldPrice: null,
    year: "2021",
    km: "51.000 km",
    fuel: "Benzina",
    power: "130 CV",
    photos: 44,
    video: true,
    stato: true,
    image:
      "https://images.unsplash.com/photo-1572811298797-9eecadf6cb24?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "cm-118745",
    ref: "CM-118745",
    brand: "Peugeot 2008",
    trim: "1.2 PureTech Allure",
    price: "14.800 €",
    oldPrice: "15.400 €",
    year: "2020",
    km: "66.500 km",
    fuel: "Benzina",
    power: "110 CV",
    photos: 33,
    video: true,
    stato: true,
    image:
      "https://images.pexels.com/photos/9943259/pexels-photo-9943259.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

export const VERIFICATION = [
  {
    n: "01",
    title: "Provenienza verificata",
    text: "Origine dell'auto e passaggi di proprietà riscontrati con la documentazione ufficiale.",
  },
  {
    n: "02",
    title: "Storico",
    text: "Controllo di sinistri, furti, atti vandalici ed eventi rilevanti sulla storia del veicolo.",
  },
  {
    n: "03",
    title: "Chilometri verificati",
    text: "Chilometri dichiarati e riscontrati con tagliandi e documentazione di manutenzione.",
  },
  {
    n: "04",
    title: "Stato d'uso",
    text: "Carrozzeria, interni, pneumatici, freni e meccanica controllati voce per voce e pubblicati nella scheda.",
  },
  {
    n: "05",
    title: "Garanzia",
    text: "Possibilità di garanzia ed estensione: ti spieghiamo le opzioni disponibili.",
  },
];

const ASSET = "https://customer-assets-eiarnc6j.emergentagent.net/job_verify-check-18/artifacts";

export const DELIVERIES = [
  `${ASSET}/c14r6xb2_gempages_575427349114258371-6044eccb-f23e-4505-b3bc-bae027e69666.jpg`,
  `${ASSET}/wipdzbgj_gempages_575427349114258371-356a9c7d-6095-4ca8-b776-d03a35a27953.jpg`,
  `${ASSET}/x1hqn7bn_gempages_575427349114258371-ff83ddcb-82c7-433a-9df7-787a2e5cfae0.jpg`,
  `${ASSET}/t0kkgcyv_gempages_575427349114258371-ae0f92f7-cf93-41cb-97d8-e24d139e2a8b.jpg`,
];

export const TIKTOK_URL = "https://www.tiktok.com/@stefano_giardino.carmaps";
export const GOOGLE_REVIEWS_URL = "https://maps.google.com/?cid=5316679387145991609";
export const MAPS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=Carmaps+Corso+Francia+115+Collegno+TO";
export const CONTACT_PAGE = "https://www.carmaps.it/pages/contact";
export const APPOINTMENT_PAGE = "https://www.carmaps.it/pages/programma-appuntamento";

export const SOCIAL_LINKS = [
  { label: "Recensioni Google", url: GOOGLE_REVIEWS_URL },
  { label: "Instagram", url: "https://www.instagram.com/carmaps.collegno/" },
  { label: "Facebook", url: "https://www.facebook.com/carmaps.collegno.corso.francia.115" },
  { label: "TikTok", url: TIKTOK_URL },
  { label: "Subito.it", url: "https://impresapiu.subito.it/shops/54192-carmaps-collegno" },
];

export const LEGAL_LINKS = [
  { label: "Privacy", url: "/privacy" },
  { label: "Condizioni", url: "/condizioni" },
];

export const PARTNERS = [
  "Carfax",
  "AutoScout24",
  "Subito.it",
  "Prima Assicurazioni",
  "Ayvens",
  "Avvera",
  "ConformGest",
];

export const TEAM = [
  {
    name: "Stefano",
    role: "UFFICIO · SELEZIONE, VERIFICA E LIVE",
    photo: `${ASSET}/qlmtz5sn_foto%20profilo%20stefano.jpeg`,
    actions: [
      { label: "Chiama", type: "phone" },
      { label: "Email", type: "email" },
    ],
  },
  {
    name: "Marco",
    role: "VENDITE E CONSEGNE · WHATSAPP UFFICIALE",
    photo: `${ASSET}/u16f2yrd_foto%20profilo%20marco.jpeg`,
    actions: [
      { label: "Chiama", type: "phone" },
      { label: "WhatsApp", type: "whatsapp" },
    ],
  },
];

export const SELL_STEPS = [
  { n: "01", label: "Valutazione" },
  { n: "02", label: "Presentazione professionale" },
  { n: "03", label: "Pubblicità multi-piattaforme" },
  { n: "04", label: "Gestione degli acquirenti" },
  { n: "05", label: "Documentazione" },
  { n: "06", label: "Assistenza fino alla vendita" },
];

export const CONTACTS = {
  address: "Corso Francia 115, 10093 Collegno (TO)",
  hours: "Lun–Ven 09:00–13:00 / 15:00–19:00 · Sab 09:00–12:00",
  ufficio: "011 283514",
  whatsapp: "333 675 9780",
  email: "collegno@carmaps.it",
  piva: "13065630017",
  rui: "E000770994",
};

// tel: uses full digits, whatsapp uses international format (Italy +39)
export const TEL_HREF = "tel:+39011283514";
export const WHATSAPP_NUMBER = "393336759780";
export const MAILTO = "mailto:collegno@carmaps.it";

export function whatsappHref(text) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

export const FOOTER_NAV = [
  { label: "Auto disponibili", to: "/auto" },
  { label: "Vendi la tua auto", to: "/#vendi" },
  { label: "Come funziona", to: "/#verifica" },
  { label: "Chi siamo", to: "/#chisiamo" },
];
